import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchInfiniteTagsArgs,
  FetchTagByIdArgs,
  FetchTagsArgs,
} from '../api/types/tags.types';

import { fetchPublicTags, fetchTagById, fetchTags } from '../api/tags.api';

export const tagsQueryKeys = createQueryKeys('tags', {
  fetchInfinitePublicTags: ({
    categoryId,
    filters,
    locale,
  }: Omit<FetchInfiniteTagsArgs, 'organizationId' | 'withPlatform'>) => ({
    queryFn: (context) =>
      fetchPublicTags({
        categoryId,
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        locale,
      }),
    queryKey: [categoryId, filters],
  }),
  fetchInfiniteTags: ({
    categoryId,
    filters,
    locale,
    organizationId,
    withPlatform = true,
  }: FetchInfiniteTagsArgs) => ({
    queryFn: (context) =>
      fetchTags({
        categoryId,
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        locale,
        organizationId,
        withPlatform,
      }),
    queryKey: [organizationId, categoryId, filters, withPlatform],
  }),
  fetchTagById: ({
    id,
    categoryId,
    locale,
    organizationId,
  }: FetchTagByIdArgs) => ({
    queryFn: () => fetchTagById({ id, categoryId, locale, organizationId }),
    queryKey: [organizationId, categoryId, id],
  }),
  fetchTags: ({
    categoryId,
    filters,
    locale,
    organizationId,
  }: FetchTagsArgs) => ({
    queryFn: () =>
      fetchTags({
        categoryId,
        filters,
        locale,
        organizationId,
      }),
    queryKey: [organizationId, categoryId, filters],
  }),
});
